export default function FAQSection() {
  const faqs = [
    {
      question: '黄游网页版需要下载安装吗？',
      answer: '不需要！黄游网页版的所有游戏均在浏览器中直接运行，无需下载任何客户端或插件，打开网页即可开始游戏，方便快捷。',
    },
    {
      question: '手机可以玩黄游网页版吗？',
      answer: '当然可以！黄游网页版完美支持手机端访问，只需在手机浏览器中打开我们的网站，即可随时随地畅玩游戏，体验与PC端同样流畅。',
    },
    {
      question: '黄游网页版有哪些类型的游戏？',
      answer: '我们提供角色扮演、动作格斗、策略战争、模拟经营、体育竞速、冒险探索、休闲益智、棋牌桌游等八大类游戏，总计超过200款精品游戏任你选择。',
    },
    {
      question: '游戏是否需要付费？',
      answer: '平台上的大部分游戏均可免费游玩，部分游戏提供内购选项但不强制消费。我们致力于为所有玩家提供公平、愉快的游戏体验。',
    },
    {
      question: '如何保存游戏进度？',
      answer: '注册并登录黄游网页版账号后，你的游戏进度将自动保存到云端。无论使用PC还是手机，只要登录同一账号即可同步进度，随时继续游戏。',
    },
    {
      question: '游戏过程中遇到卡顿怎么办？',
      answer: '建议使用Chrome、Edge或Firefox等主流浏览器，并确保浏览器已更新到最新版本。同时关闭不必要的后台应用，使用稳定的Wi-Fi网络可获得更流畅的体验。',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于黄游网页版的常见疑问，这里都有答案
          </p>
        </div>
        <div className="flex flex-col gap-4">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-6 py-4 text-sm md:text-base font-medium text-foreground-800 hover:text-primary-600 transition-colors duration-200 list-none">
                {faq.question}
                <i className="ri-add-line text-lg text-foreground-400 group-open:hidden"></i>
                <i className="ri-subtract-line text-lg text-primary-600 hidden group-open:block"></i>
              </summary>
              <div className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}